import TransportRequest from 'js/pages/transport-request'
import GeneralConditionsOfTransport from 'js/pages/general-conditions-of-transport'
import InstitutionalInformation from 'js/pages/institutional-information'
import cookiesPolicy from 'js/pages/cookies-policy-text'

export default [
  {
    path: '/transport-request',
    name: 'transport-request',
    component: TransportRequest,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/general-conditions-of-transport',
    name: 'general-conditions-of-transport',
    component: GeneralConditionsOfTransport,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/institutional-information',
    name: 'institutional-information',
    component: InstitutionalInformation,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/cookies-policy-text',
    name: 'cookies-policy-text',
    component: cookiesPolicy,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
]